import React from "react";
import "./NotFound.css";

export default class NotFound extends React.Component {
  // This component is shown when the user types in the address bar an invalid page.
  render() {
    return (
      <div className="NotFound">
        <h3>Sorry, this page was not found!</h3>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js